import { createFilledIcon } from "../createIcon";

export const LightningFilledIcon = createFilledIcon(
  <>
    <path d="m4.598 14.519 7.355-11.383c.406-.628 1.38-.341 1.38.407v6.135a.1.1 0 0 0 .1.1h5.409a.6.6 0 0 1 .49.946L12.03 21.07c-.422.597-1.362.299-1.362-.433v-5.093a.1.1 0 0 0-.1-.1H5.102a.6.6 0 0 1-.504-.925Z" />
  </>,
  "LightningFilledIcon"
);
